export default "__VITE_ASSET__CMps_1$E__"